import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "FindOrderHome",
    component: () => import(/* webpackChunkName: "singleChunk" */ "../views/FindOrder.vue")
  },
  {
    path: "/:transref/order-multi",
    name: "MultiOrder",
    component: () => import(/* webpackChunkName: "singleChunk" */ "../views/OrderMulti.vue")
  },

  {
    path: "/order-processing",
    name: "OrderProcessing",
    component: () => import(/* webpackChunkName: "singleChunk" */ "../views/OrderNotFound.vue")
  },
  {
    path: "/:transref/order-progress",
    name: "OrderProgress",
    component: () => import(/* webpackChunkName: "singleChunk" */ "../views/OrderProgress.vue")
  },
  {
    path: "/:transref/order-progress/:productIndex",
    name: "OrderProgressPage",
    component: () => import(/* webpackChunkName: "singleChunk" */ "../views/OrderProgress.vue")
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
